import { ref } from 'config/constants'
import { showMessage } from 'data/messages/actions';
import { 
  FETCH_ORDERS,
  FETCH_ORDERS_SUCCESS,
  UPDATE_ORDER,
 } from './types';
import { OrderStatus } from 'data/orders/types';

const Orders = ref.child("campaigns");

export function fetchOrders() {
  return dispatch => {
    dispatch({
      type: FETCH_ORDERS,
      payload: {pending: true}
    });
    Orders.on('value', snapshot => {
      dispatch({
        type: FETCH_ORDERS_SUCCESS,
        payload: snapshot.val()
      });
    });
  };
}

export function deleteOrder(accountid, key) {
    return dispatch => Orders.child(accountid).child(key).remove();
}

export function updateOrder(accountid, key, order) {
  return dispatch => {
    dispatch({type: UPDATE_ORDER, payload: { pending : true } })
    return Orders.child(order.accountid).child(key).child("details").set(order).
      then( () => {
          dispatch(showMessage(`"${order.name}" har ändrat status till: ${OrderStatus[order.status]}`) )
      }).
      catch( (error) => {
          dispatch(showMessage(error.message) )
      }).
      then( () => {
          dispatch({type: UPDATE_ORDER, payload: { pending : false } })
      })
  }
}


export function updateBooking(accountid, key, booking) {
  return dispatch => {
    dispatch({type: UPDATE_ORDER, payload: { pending : true } })
    return Orders.child(accountid).child(key).child("bookings").set(booking).
      then( () => {
          dispatch(showMessage(`Bokningen har uppdaterats`) )
      }).
      catch( (error) => {
          dispatch(showMessage(error.message) )
      }).
      then( () => {
          dispatch({type: UPDATE_ORDER, payload: { pending : false } })
      })
  }
}



// WEBPACK FOOTER //
// ./src/data/orders/actions.js